import React from 'react';

import { CONTENT_LISTS } from '@lumapps/content-lists/keys';
import { NavigationItemType } from '@lumapps/navigation/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemWizardOptionProps } from '../../types';
import { ContentWizardOption } from './ContentWizardOption';

export const ContentListWizardOption: React.FC<NavigationItemWizardOptionProps> = ({
    fetchAtInstanceLevel,
    ...props
}) => {
    const { translateKey } = useTranslate();

    const description = translateKey(
        fetchAtInstanceLevel
            ? CONTENT_LISTS.CONTENT_TYPE_LISTS_FROM_YOUR_SITE
            : NAVIGATION_ADMIN.PICK_CONTENT_LIST_DESCRIPTION,
    );

    return (
        <ContentWizardOption
            {...props}
            name={translateKey(GLOBAL.CONTENT_LIST)}
            description={description}
            pickerType={NavigationItemType.CUSTOM_LIST}
            id="content-list"
        />
    );
};
